import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { IAN_GRADIENTS } from "../../theme/ianTokens";

const useStyles = makeStyles({
  bar: {
    width: "100%",
    height: "4px",
    backgroundImage: IAN_GRADIENTS.primary,
    flexShrink: 0,
  },
});

/**
 * 4px IAN primary gradient bar — full-width, reusable.
 * Placed at the top of the taskpane header.
 */
const GradientBar = () => {
  const styles = useStyles();
  return <div className={styles.bar} />;
};

export default GradientBar;
